import brand from "../../../assets/images/brand.svg";
import * as Styles from "../Home.styles";

export default function HomeDecorations() {
  return (
    <>
      <Styles.Brand src={brand} alt="marca da zeus" />
      <Styles.WavyCircle position="bottom" />
      <Styles.WavyCircle position="top" />
    </>
  );
}
